<app-dashboard-layout [notDashboard]="true" [downloader]="downloader" [loading]="loading">
  <app-notification-alert [data]="notification"></app-notification-alert>

  <section class="bg-white border rounded-md p-6">
    <header class="border-b text-lg w-full pb-2 md:text-xl">
      Accommodation Payment Confirmation
    </header>

    <div class="pt-6 space-y-4">
      <div class="bg-green-50 border border-green-200 rounded-md p-4 text-sm text-gray-700 space-y-1">
        <p class="font-semibold text-green-800">Payment Confirmed</p>
        <p>Your accommodation reservation has been fully paid. Click the button below to download your confirmation document.</p>
      </div>

      <div class="flex justify-center">
        <app-button-primary
          (click)="downloadConfirmation()"
          [disabled]="loading"
          class="w-1/2"
        >
          Download Confirmation
        </app-button-primary>
      </div>
    </div>
  </section>
</app-dashboard-layout>
